import React, { cloneElement, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import Footer from './Footer'
import Header from './Header'
import Sidebar from './Sidebar'
import { useLocation } from 'react-router-dom'
import { CHECKAUTH } from '../../constants/ActionTypes'
import { Spin } from 'antd'

const layoutConf = {
  sidebarWidth: '200px',
  headerHeight: '42px'
}

const MainWrapper = styled.main`
  height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
  display: flex;

  &::-webkit-scrollbar {
    display: none;
  }
`

const SidebarWrapper = styled.div`
  width: ${({ width, showSidebar }) => showSidebar ? width || '150px' : '0px'};
  height: 100%;
  z-index: 3;
  overflow: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
  transition: all 0.5s;
  -webkit-transition: all 0.25s;
`

const InnerWrapper = styled.div`
  width: ${({ sidebar, showSidebar }) => showSidebar ? `calc(100% - ${sidebar || '150px'})` : '100%'};
`

const ContentWrapper = styled.div`
  height: calc(100% - ${({ header }) => header || '42px'});
  min-width: ${({ sidebar, showSidebar }) => showSidebar ? `calc(100% - ${sidebar || '150px'})` : '100%'};
  display: flex;
  flex-direction: column;
  padding: 8px;
  overflow: scroll;
  // justify-content: space-between;
`

function AppContainer (props) {
  const { children } = props
  const [showSidebar, setShowSidebar] = useState(true)
  const [changeGroupLoading, setChangeGroupLoading] = useState(false)
  const dispatch = useDispatch()
  const location = useLocation()
  const { pathname } = location

  useEffect(() => {
    dispatch({ type: CHECKAUTH.REQUEST })
  }, [pathname])

  return <MainWrapper>
      <SidebarWrapper width={layoutConf.sidebarWidth} showSidebar={showSidebar}>
        <Sidebar layoutConf={layoutConf} />
      </SidebarWrapper>
      <InnerWrapper sidebar={layoutConf.sidebarWidth} showSidebar={showSidebar}>
        <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} layoutConf={layoutConf} setChangeGroupLoading={setChangeGroupLoading} />
        <ContentWrapper header={layoutConf.headerHeight} footer={layoutConf.footerHeight} sidebar={layoutConf.sidebarWidth} showSidebar={showSidebar}>
          {changeGroupLoading ? <Spin style={{ marginTop: '240px' }} /> : cloneElement(children)}
          <Footer />
        </ContentWrapper>
      </InnerWrapper>
    </MainWrapper>
}

export default AppContainer
